import React, { useEffect, useMemo, useState } from "react";
import { Building2 } from "lucide-react";
import { getBusinessLogoUrl } from "../utils/api";

export default function BusinessLogo({ businessId, className = "" }) {
  const [imageError, setImageError] = useState(false);
  const cacheKey = useMemo(() => Date.now(), [businessId]);

  const logoUrl = useMemo(() => {
    return getBusinessLogoUrl(businessId, cacheKey);
  }, [businessId, cacheKey]);

  useEffect(() => {
    setImageError(false);
  }, [logoUrl]);

  const showImage = Boolean(logoUrl) && !imageError;

  return (
    <div className={`business-logo ${className}`.trim()}>
      {showImage ? (
        <img
          src={logoUrl}
          alt="Isletme logosu"
          className="business-logo-img"
          onError={() => setImageError(true)}
        />
      ) : (
        <Building2 className="business-logo-fallback" />
      )}
    </div>
  );
}
